// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".badge[data-v-6cb3fe23] {\n  border-radius: 4px;\n  font-size: 0.715rem;\n  display: inline-block;\n  padding: 0.2rem 0.4rem;\n  letter-spacing: 0.92px;\n  text-transform: uppercase;\n  font-weight: bold;\n}\n.badge.default[data-v-6cb3fe23] {\n  background-color: #eca58f;\n  color: #fff;\n}\n.badge.primary[data-v-6cb3fe23] {\n  background-color: #7d8bf7;\n  color: #fff;\n}", ""]);
// Exports
module.exports = exports;
